import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useSelector } from "react-redux";
import Navbar from "@/components/organisms/Navbar";
import Hero from "@/components/organisms/Hero";
import About from "@/components/organisms/About";
import Skills from "@/components/organisms/Skills";
import Experience from "@/components/organisms/Experience";
import Projects from "@/components/organisms/Projects";
import EducationAndCerts from "@/components/organisms/EducationAndCerts";
import Contact from "@/components/organisms/Contact";
import Footer from "@/components/organisms/Footer";
import CommandPalette from "@/components/organisms/CommandPalette";
import CustomCursor from "@/components/molecules/CustomCursor";
import ScrollProgress, { ScrollToTop } from "@/components/molecules/ScrollProgress";
import Loader from "@/components/molecules/Loader";
import NotFound from "@/pages/NotFound";
import { ThemeManager } from "@/components/molecules/ThemeToggle";
import Lenis from "lenis";

function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Loader />
      <ScrollProgress />
      <CustomCursor />
      <div className="noise-overlay" />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <EducationAndCerts />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
      <CommandPalette />
    </>
  );
}

function AppShell() {
  const themeMode = useSelector((s) => s.theme.mode);
  return (
    <BrowserRouter>
      <ThemeManager />
      <Toaster theme={themeMode === "dark" ? "dark" : "light"} position="bottom-right" />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <div className="App">
      <AppShell />
    </div>
  );
}

export default App;
